import React, { useState, useEffect } from 'react';
import {
    Book, BarChart, Search, Add, Edit,
    Delete, School, People, Menu, Close, Warning
} from '@mui/icons-material';
import Box from '@mui/material/Box';
import { Typography, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';

// Custom Delete Confirmation Dialog Component
const DeleteConfirmationDialog = ({ open, onClose, onConfirm, courseTitle }) => {
    return (
        <Dialog 
            open={open} 
            onClose={onClose}
            sx={{ 
                fontFamily: "'Satoshi', sans-serif",
                '& .MuiDialog-paper': {
                    borderRadius: '12px',
                    padding: '10px',
                    maxWidth: '450px'
                }
            }}
        >
            <DialogTitle sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: '10px',
                fontFamily: "'Satoshi', sans-serif",
                fontWeight: 'bold',
                color: '#e33e1d',
                padding: '16px 16px 10px 16px'
            }}>
                <Warning sx={{ fontSize: '24px' }} />
                Confirm Deletion
            </DialogTitle>
            
            <Box sx={{ position: 'absolute', top: '10px', right: '10px' }}>
                <Close 
                    onClick={onClose}
                    sx={{ 
                        cursor: 'pointer', 
                        color: '#7f8c8d',
                        '&:hover': { color: '#333' }
                    }} 
                />
            </Box>
            
            <DialogContent sx={{ fontFamily: "'Satoshi', sans-serif", padding: '0 16px' }}>
                <Typography sx={{ fontFamily: "'Satoshi', sans-serif", marginBottom: '10px' }}>
                    Are you sure you want to delete the course:
                </Typography>
                <Typography sx={{ 
                    fontFamily: "'Satoshi', sans-serif", 
                    fontWeight: 'bold', 
                    color: '#332872',
                    padding: '8px 12px',
                    backgroundColor: '#f5f7fa',
                    borderRadius: '4px'
                }}>
                    {courseTitle}
                </Typography>
                <Typography sx={{ 
                    fontFamily: "'Satoshi', sans-serif", 
                    marginTop: '15px',
                    color: '#e33e1d',
                    fontSize: '14px'
                }}>
                    This action cannot be undone.
                </Typography>
            </DialogContent>
            
            <DialogActions sx={{ 
                padding: '16px', 
                gap: '10px',
                justifyContent: 'center'
            }}>
                <Button 
                    onClick={onClose}
                    variant="outlined"
                    sx={{
                        fontFamily: "'Satoshi', sans-serif",
                        textTransform: 'none',
                        borderRadius: '6px',
                        padding: '8px 20px',
                        borderColor: '#7f8c8d',
                        color: '#7f8c8d',
                        '&:hover': {
                            borderColor: '#5d6d71',
                            backgroundColor: '#f5f7fa'
                        }
                    }}
                >
                    Cancel
                </Button>
                <Button 
                    onClick={onConfirm}
                    variant="contained"
                    sx={{
                        fontFamily: "'Satoshi', sans-serif",
                        textTransform: 'none',
                        borderRadius: '6px',
                        padding: '8px 20px',
                        backgroundColor: '#e33e1d',
                        '&:hover': {
                            backgroundColor: '#c13515'
                        }
                    }}
                >
                    Delete Course
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteConfirmationDialog;